var map = {
	"./en-takeda-consent-form.html": "./src/locales/takeda/consent-form/en-takeda-consent-form.html",
	"./ja-takeda-consent-form.html": "./src/locales/takeda/consent-form/ja-takeda-consent-form.html"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/locales/takeda/consent-form sync recursive ^\\.\\/.*\\-takeda\\-consent\\-form\\.html$";